import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ElementBaseQuickSettingRect, IQuickSettingRect } from './base';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';

const MUTI_QUCIKBAR_PADDING = 14;
const DEFAULT_RECT = { left: 0, top: 0, width: 0, height: 0 };
export const DEFAULT_QUICK_SETTING_RECT = { x: 0, y: 0, width: 0, height: 0 };

export class MultiplyQuickSettingRect {
    private multiModel: IMultiplyModel;
    public constructor(model: IMultiplyModel) {
        this.multiModel = model;
    }

    public getQuickSettingRect(scale: number): IQuickSettingRect {
        if (!this.multiModel.selectedModels) return DEFAULT_QUICK_SETTING_RECT;
        const [firstModel] = this.multiModel.selectedModels;
        const outerFrame = firstModel?.getFrame?.().outerFrameOnSlide();
        const rect = firstModel.type === UIModelType.GROUP
            ? ElementBaseQuickSettingRect.modifyGroupRect({ ...DEFAULT_RECT, ...outerFrame })
            : { ...DEFAULT_RECT, ...outerFrame };
        const frame = {
            left: rect.left,
            top: rect.top,
            right: rect.left + rect.width,
            bottom: rect.top + rect.height,
        };
        this.multiModel.selectedModels.forEach((child) => {
            const outerFrame = child?.getFrame?.().outerFrameOnSlide();
            const rect = child.type === UIModelType.GROUP
                ? ElementBaseQuickSettingRect.modifyGroupRect({ ...DEFAULT_RECT, ...outerFrame })
                : { ...DEFAULT_RECT, ...outerFrame };
            frame.left = Math.min(frame.left, rect.left);
            frame.top = Math.min(frame.top, rect.top);
            frame.right = Math.max(frame.right, rect.left + rect.width);
            frame.bottom = Math.max(frame.bottom, rect.top + rect.height);
        });

        const { leftOffset, topOffset } = ElementBaseQuickSettingRect.getOffset();
        return {
            x: (frame.left * scale) + leftOffset,
            y: (frame.top * scale) + topOffset - MUTI_QUCIKBAR_PADDING,
            width: (frame.right - frame.left) * scale,
            height: ((frame.bottom - frame.top) * scale) + (MUTI_QUCIKBAR_PADDING * 2),
        };
    }
}
